export default {"src":"/_next/static/media/10lbs.c40082db.svg","height":132,"width":180,"blurWidth":0,"blurHeight":0};